import FiledCustomTypes from './TableTypes';
import DataTable from './DataTable';

export default {
  FiledCustomTypes,
  DataTable
};
